/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type PdpSharedStorytellingRelatedContent_item = {
    readonly vertical: VerticalType | null;
    readonly " $refType": "PdpSharedStorytellingRelatedContent_item";
};
export type PdpSharedStorytellingRelatedContent_item$data = PdpSharedStorytellingRelatedContent_item;
export type PdpSharedStorytellingRelatedContent_item$key = {
    readonly " $data"?: PdpSharedStorytellingRelatedContent_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingRelatedContent_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedStorytellingRelatedContent_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ebd33b0a66d76fd0fd44eb09bcbfaec8';
export default node;
